import { render, staticRenderFns } from "./EditionTranslations_ErrorBox.vue?vue&type=template&id=78050ea1"
import script from "./EditionTranslations_ErrorBox.vue?vue&type=script&lang=js"
export * from "./EditionTranslations_ErrorBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports